import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Header from "@/components/Header";
import MobileNav from "@/components/MobileNav";

import Home from "@/pages/Home";
import Search from "@/pages/Search";
import PropertyDetail from "@/pages/PropertyDetail";
import AuthPage from "@/pages/AuthPage";
import OwnerDashboard from "@/pages/OwnerDashboard";
import BuyerDashboard from "@/pages/BuyerDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import ListProperty from "@/pages/ListProperty";

function Protected({ children, roles }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="min-h-screen flex items-center justify-center text-slate-400">Loading…</div>;
  if (!user) return <Navigate to="/auth" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return children;
}

function Shell() {
  const loc = useLocation();
  const hideChrome = loc.pathname === "/auth";
  return (
    <div className="min-h-screen bg-[#070C1E]">
      {!hideChrome && <Header />}
      <main className={hideChrome ? "" : "pt-16"}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/search" element={<Search />} />
          <Route path="/property/:id" element={<PropertyDetail />} />
          <Route path="/auth" element={<AuthPage />} />
          <Route path="/list-property" element={<Protected roles={["owner", "admin"]}><ListProperty /></Protected>} />
          <Route path="/owner" element={<Protected roles={["owner", "admin"]}><OwnerDashboard /></Protected>} />
          <Route path="/buyer" element={<Protected roles={["buyer", "owner", "admin"]}><BuyerDashboard /></Protected>} />
          <Route path="/admin" element={<Protected roles={["admin"]}><AdminDashboard /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>
      {!hideChrome && <MobileNav />}
    </div>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Shell />
        <Toaster position="top-center" theme="dark" richColors />
      </BrowserRouter>
    </AuthProvider>
  );
}
